import { inject, Injectable } from '@angular/core'
import { Action, select, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

import * as ProjectorContainersSelectors from './projector-containers.selectors'

@Injectable({
  providedIn: 'root',
})
export class ProjectorContainersFacade implements GbBaseFacade {
  private readonly store = inject(Store)

  projectorContainersLoaded$ = this.store.pipe(select(ProjectorContainersSelectors.selectProjectorContainersLoaded))
  allProjectorContainers$ = this.store.pipe(select(ProjectorContainersSelectors.selectAllProjectorContainersList))
  selectedProjectorContainer$ = this.store.pipe(select(ProjectorContainersSelectors.selectSelectedProjectorContainer))
  projectorContainersEditCreateLoaded$ = this.store.pipe(
    select(ProjectorContainersSelectors.selectProjectorContainersEditCreateLoaded),
  )
  projectorContainerDataIsLoading$ = this.store.pipe(
    select(ProjectorContainersSelectors.selectProjectorContainerDataIsLoading),
  )
  projectorContainerDataIsReady$ = this.store.pipe(
    select(ProjectorContainersSelectors.selectProjectorContainerDataIsReady),
  )

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
